function init() {

    var dlg_userLostPw = $("#user-lostpw").dialog({
        autoOpen: false,
        title: 'Passwort vergessen',
        width: '30em',
        modal: true,
        buttons: [{
            text: 'Abbrechen',
            class: 'cancel',
            click: function() {
                $(this).dialog("close");
            }
        }, {
            text: 'Anfordern',
            class: 'ok',
            click: function() {
                $.ajax({
                    type: 'POST',
                    url: '/Handler/User/UserPW',
                    data: {
                        data: {
                            'mail': $('#pwmail').val()
                        }
                    }
                }).done(function(data) {
                    //if (data === "ok") {
                    confirm("Es wurde eine Email mit Anweisungen an " + $('#pwmail').val() + " versendet.");
                    //}
                    $('#user-lostpw').dialog("close");
                });

            }
        }],
        close: function() {}
    });
    $('#user-lostpw').show();
    /* Passwort vergessen */
    $('#btn-lostpw').click(function(event) {
        dlg_userLostPw.dialog('open');
    });

    /* Nutzerverwaltung */
    if ($('#hvd-phone-edit').length > 0) {
        var hvdPhoneTitle = $('#hvd-phone-edit')[0].title;
        var hvdPhoneValue = $('#hvdPhone').val();
        $('#hvd-phone-edit').click(function(event) {
            $('.hvd-phone span').toggle();
            $('#hvdPhone').toggle();
        });

        $('.hvd-phone .cancel').click(function(event) {
            $('#hvdPhone').val(hvdPhoneValue);
            $('.hvd-phone span').html(hvdPhoneValue);
            if ($('#hvdPhone').is(":visible")) {
                $('#hvd-phone-edit').click();
            }
        });
        $('.hvd-phone .ok').click(function(event) {
            if ($('#hvdPhone').val() !== hvdPhoneValue) {
                $.ajax({
                    type: 'POST',
                    url: '/Handler/User/HvDChange',
                    data: {
                        data: {
                            'id': $('#hvdSelect').val(),
                            'telefon': $('#hvdPhone').val()
                        }
                    }
                }).done(function(data) {
                    if (data === "ok") location.reload();
                });
            }
        });
    }
    /* HVD Auswahlmenu */

    var dlg_hvdChange = $("#hvd-change").dialog({
        autoOpen: false,
        title: 'HVD wechseln',
        width: '50em',
        modal: true,
        close: function() {
            $("#hvdSelect").val(curHvd);
            $("#hvdSelect").selectmenu('refresh');
        }
    });

    $(dlg_hvdChange).find('.cancel').click(function(event) {
        dlg_hvdChange.dialog("close");
    });

    $(dlg_hvdChange).find('.ok').click(function(event) {
        curHvd = $('#hvdSelect').val();
        dlg_hvdChange.dialog("close");
        var data = {
            data: {
                id: curHvd,
                telefon: $('#hvdPhone').val()
            }
        };
        // curHvd setzen
        $.ajax({
            type: 'POST',
            url: '/Handler/User/HvDChange',
            data: data
        }).done(function(data) {
            if (data === "ok") location.reload();
        });
    });

    var curHvd = $('#hvdSelect').val();

    $("#hvdSelect").selectmenu({
        change: function(event, data) {
            $(dlg_hvdChange).find('#hvd-new-user').html(data.item.label);
            dlg_hvdChange.dialog("open");
        }
    });

    /* Nutzer anlegen */
    var dlg_newuser = $("#user-new").dialog({
        autoOpen: false,
        title: 'Neuen Nutzer anlegen',
        width: '50em',
        modal: true
    });
    $(dlg_newuser).find('.cancel').click(function(event) {
        dlg_newuser.dialog("close");
    });

    var dlg_validateuser = $("#user-new-validate").dialog({
        autoOpen: false,
        title: 'Fehler',
        width: '22em',
        modal: true
    });
    $(dlg_validateuser).find('.cancel').click(function(event) {
        dlg_validateuser.dialog("close");
    });

    var dlg_failuser = $("#user-new-fail").dialog({
        autoOpen: false,
        title: 'Fehler',
        width: '31em',
        modal: true
    });
    $(dlg_failuser).find('.cancel').click(function(event) {
        dlg_failuser.dialog("close");
    });

    var dlg_mailuser = $("#user-new-mail").dialog({
        autoOpen: false,
        title: 'Fehler',
        width: '31em',
        modal: true
    });
    $(dlg_mailuser).find('.cancel').click(function(event) {
        dlg_mailuser.dialog("close");
    });


    $(dlg_newuser).find('.ok').click(function(event) {
        if (!validate($(dlg_newuser).find('.required'))) {
            dlg_validateuser.dialog("open");
            return;
        }
        if (!validateMail($(dlg_newuser).find('.mail'))) {
            dlg_mailuser.dialog("open");
            return;
        }


        /* Nutzer anlegen */
        var $data = $(dlg_newuser).find('input, select');
        var data = {};
        $data.each(function(i, el) {
            data[el.name] = el.value;
        });
        $.ajax({
                type: 'POST',
                url: '/Handler/User/UserCreate',
                data: {
                    data: data
                }
            })
            .done(function(data, state, jqxhr) {
                if (data === "ok") {
                    location.reload();
                } else {
                    dlg_failuser.dialog("open");
                }
            })
            .fail(function(data, textStatus, errorThrown) {
                console.debug(textStatus);
                console.debug(errorThrown);
            });

    });

    $(".dropdown").selectmenu({
        width: '13.5em'
    });
    $('.user-add').click(function(event) {
        dlg_newuser.dialog("open");
        return false;
    });


    var dlg_deleteuser = $("#user-delete").dialog({
        autoOpen: false,
        title: 'Nutzer löschen',
        width: '34em',
        modal: true
    });
    $(dlg_deleteuser).find('.cancel').click(function(event) {
        dlg_deleteuser.dialog("close");
    });

    $('.icon-cancel').click(function(event) {
        $(dlg_deleteuser).find('#user-name').html($(this).attr('data-name'));
        $(dlg_deleteuser).find('.ok').attr('data-id', $(this).attr('data-id'));
        dlg_deleteuser.dialog('open');
    });
    $(dlg_deleteuser).find('.ok').click(function(event) {
        var data = {
            id: $(this).attr('data-id')
        };
        $.ajax({
                type: 'POST',
                url: '/Handler/User/UserDelete',
                data: {
                    data: data
                }
            })
            .done(function(data, state, jqxhr) {
                if (data === "ok") location.reload();
            })
            .fail(function(data, textStatus, errorThrown) {
                console.debug(textStatus);
                console.debug(errorThrown);
            });
    });

    $('.user-edit button.ok').click(function(event) {
        var id = $(this).attr('data-id');
        var userBody = $('.list-body[data-item="' + id + '"]');
        //list-body data-item
        var $data = $(userBody).find('input, select');

        var data = {};
        $data.each(function(i, el) {
            data[el.name] = el.value;
        });
        data['id'] = id;
        $.ajax({
                type: 'POST',
                url: '/Handler/User/UserUpdate',
                data: {
                    data: data
                }
            })
            .done(function(data, state, jqxhr) {
                if (data === "ok") {
                    location.reload();
                } else {
                    console.debug("FAIL");
                    dlg_failuser.dialog("open");
                }
            })
            .fail(function(data, textStatus, errorThrown) {
                console.debug(textStatus);
                console.debug(errorThrown);
            });

    });



    /* Felder validieren */
    function validateMail($items) {
        var retVal = true;
        for (var i = 0; i < $items.length; i++) {
            if ($($items[i]).val() !== '' && !isEmail($($items[i]).val())) {
                $($items[i]).css('border', '1px solid red');
                retVal = false;
            } else {
                $($items[i]).css('border', '');
            }
        }
        return retVal;
    }


    /* Felder validieren */
    function validate($items) {
        var retVal = true;
        for (var i = 0; i < $items.length; i++) {
            if ($($items[i]).val() === '') {
                $($items[i]).css('border', '1px solid red');
                retVal = false;
            } else {
                $($items[i]).css('border', '');
            }
        }
        return retVal;
    }

    /* Passwort ändern */
    $('#pw-err').hide();
    var dlg_changePw = $('#dlg-pw-change').dialog({
        autoOpen: false,
        title: 'Password ändern',
        width: '30em',
        modal: true,
        buttons: [{
            text: 'Ändern',
            class: 'ok',
            click: function() {
                if ($(this).find('.user-pw-1').val().trim().length === 0) {
                    // Keine änderung
                    tools.toast('Passwort', 'Passwort wurde nicht geändert');
                    $(this).dialog("close");
                    $('#pw-setpw').addClass('hidden');
                    return;
                }
                if ($(this).find('.user-pw-1').val().trim() !== $(this).find('.user-pw-2').val().trim()) {
                    // Passwörter nicht identisch
                    $(this).find('.form-group').addClass('has-error');
                    $(this).find('#pw-err').show();
                    $(this).find('#pw-setpw').addClass('hidden');
                    return;
                }
                // Speichern
                $.ajax({
                    type: 'POST',
                    url: '/Handler/User/UserUpdate',
                    data: {
                        data: {
                            type: 'pw',
                            pw: $(this).find('.user-pw-1').val(),
                            id: dlg_changePw.uid
                        }
                    }
                }).done(function(data, state, jqxhr) {
                    if (data === 'ok') {
                        tools.toast('Passwort', 'Passwort wurde geändert');
                        dlg_changePw.dialog("close");
                        $(this).find('#pw-err').hide();
                        $(this).find('#pw-setpw').addClass('hidden');
                    } else {
                        console.debug("FAIL");
                        dlg_failuser.dialog("open");
                    }

                }).fail(function(data, textStatus, errorThrown) {
                    console.debug(textStatus);
                    console.debug(errorThrown);
                });

            }
        }, {
            text: 'Abbrechen',
            class: 'cancel',
            click: function() {
                $(this).dialog("close");
                $('#pw-setpw').addClass('hidden');
            }
        }]
    });
    $('.editPw').click(function(event) {
        $('#pw-err').hide();
        dlg_changePw.uid = $(this).attr('data-id');
        openChangePw(dlg_changePw);
    });

    if ($.params().indexOf('setpw') > -1) {
        openChangePw(dlg_changePw, false);
    }

    function openChangePw(dlg_changePw, disableClose = false) {
        // https://wupperverband-v2.ddev.site//?fpw=1c36e9f3c14c584f8a9deab129b0a65b5b71e731285670598c608d5950b6de23
        /** @type  {Array<HTMLElement>} btn */
        let btnClose = [dlg_changePw[0].parentElement.querySelector('button.cancel'), dlg_changePw[0].parentElement.querySelector('button.ui-dialog-titlebar-close')];
        console.log(btnClose);
        if (!disableClose) {
            btnClose.forEach(btn => {
                btn.disabled = true;
            });
        } else {
            btnClose.forEach(btn => {
                btn.disabled = false;
            });
        }
        $(dlg_changePw).find('.user-pw-1,.user-pw-2').val('');
        $(dlg_changePw).find('#pw-err').hide();
        $(dlg_changePw).find('.form-group').removeClass('has-error');
        $('#pw-err').hide();
        dlg_changePw.dialog('open');
    }

}
init();
